"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtiIntegrationPendoService = void 0;
var cookies_category_model_1 = require("../model/cookies-category.model");
var OtiIntegrationPendoService = /** @class */ (function () {
    function OtiIntegrationPendoService(cookiePreferenceChange$, logService) {
        this.cookiePreferenceChange$ = cookiePreferenceChange$;
        this.logService = logService;
        this.pendoTimeLapse = 1000;
        this.requestWithCredentials = false;
        this.initTimeout = null;
        this.isTrackingEnabled = false;
        this.requestTimeout = null;
        this.sessionWriteTimeout = null;
        this.untrackedEvents = [];
    }
    OtiIntegrationPendoService.prototype._applyTemplatesToUrl = function (url) {
        return url.replace(/\$\{visitorId}/g, this._getVisitorId());
    };
    OtiIntegrationPendoService.prototype._callDNP = function (dnpValue) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.logService.log('Call DNP request. val=', dnpValue);
            if (!_this.pendoDnpUrl || !_this.pendoDnpMethod) {
                throw new Error('Missing pendo parameters');
            }
            _this._executeDelayedRequest(_this._applyTemplatesToUrl(_this.pendoDnpUrl), _this.pendoDnpMethod, JSON.stringify(dnpValue))
                .then(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.logService.log('Call DNP success');
                    resolve(dnpValue);
                    return [2 /*return*/];
                });
            }); })
                .catch(function (error) {
                console.error('There was an error!', error);
                reject();
            });
        });
    };
    OtiIntegrationPendoService.prototype._createVisitorId = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!_this.pendoVisitorUrl || !_this.pendoVisitorMethod) {
                throw new Error('Missing pendo parameters');
            }
            var payload = _this._getVisitorPayload();
            _this.logService.log('CreateVisitorId request.', payload);
            _this._executeDelayedRequest(_this._applyTemplatesToUrl(_this.pendoVisitorUrl), _this.pendoVisitorMethod, payload ? JSON.stringify(payload) : null)
                .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (response.status === 200) {
                        this.logService.log('CreateVisitorId success');
                        resolve();
                    }
                    else {
                        console.error('CreateVisitorId failed!');
                        reject();
                    }
                    return [2 /*return*/];
                });
            }); })
                .catch(function (error) {
                console.error('There was an error!', error);
                reject();
            });
        });
    };
    OtiIntegrationPendoService.prototype._digestUntrackedEvents = function () {
        var _this = this;
        if (this.isTrackingEnabled) {
            this.untrackedEvents.forEach(function (evt) { return _this._trackPendoEvent(evt); });
            this.untrackedEvents = [];
        }
    };
    OtiIntegrationPendoService.prototype._disablePendo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pendoLib;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logService.log('Disable pendo');
                        return [4 /*yield*/, this._getPendoLibraryAsync()];
                    case 1:
                        pendoLib = _a.sent();
                        if (pendoLib.isReady()) {
                            pendoLib.stopGuides();
                            pendoLib.stopSendingEvents();
                        }
                        this.isTrackingEnabled = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    OtiIntegrationPendoService.prototype._enablePendo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pendoLib;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._getPendoLibraryAsync()];
                    case 1:
                        pendoLib = _a.sent();
                        if (pendoLib.isReady()) {
                            this.logService.log('Enable pendo');
                            pendoLib.startGuides();
                            pendoLib.startSendingEvents();
                        }
                        else {
                            this.logService.log('Initialize pendo');
                            pendoLib.initialize(__assign(__assign({}, this._getPendoDetails()), { contentHost: this.pendoCNameContent, dataHost: this.pendoCNameData }));
                        }
                        this.isTrackingEnabled = true;
                        this._digestUntrackedEvents();
                        return [2 /*return*/];
                }
            });
        });
    };
    OtiIntegrationPendoService.prototype._executeRequest = function (url, method, body) {
        if (body === void 0) { body = null; }
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if (this.requestHeaders) {
            for (var hname in this.requestHeaders) {
                if (this.requestHeaders[hname]) {
                    headers.append(hname, this.requestHeaders[hname]);
                }
            }
        }
        var credentials = this.requestWithCredentials ? 'include' : undefined;
        var request = new Request(url, {
            method: method,
            headers: headers,
            credentials: credentials,
            body: body,
        });
        return fetch(request);
    };
    OtiIntegrationPendoService.prototype._executeDelayedRequest = function (url, method, body) {
        var _this = this;
        if (body === void 0) { body = null; }
        return new Promise(function (resolve, reject) {
            // this timeout is added because Pendo allows only one API call
            // per second per visitor
            var remainingTime = _this.requestTimeout
                ? _this.pendoTimeLapse - (new Date().getTime() - _this.requestTimeout)
                : 0;
            if (remainingTime > 0) {
                window.setTimeout(function () {
                    _this._executeDelayedRequest(url, method, body).then(resolve).catch(reject);
                }, remainingTime);
            }
            else {
                _this.requestTimeout = new Date().getTime();
                _this._executeRequest(url, method, body).then(resolve).catch(reject);
            }
        });
    };
    OtiIntegrationPendoService.prototype._generateAnonymousVisitorId = function () {
        var visitorId;
        if (typeof this.pendoVisitorIdGenerator === 'function') {
            visitorId = this.pendoVisitorIdGenerator();
        }
        else {
            var pendoLib = this._getPendoLibrary();
            visitorId = pendoLib ? pendoLib.get_visitor_id() : '';
        }
        return visitorId;
    };
    OtiIntegrationPendoService.prototype._getAnonymousVisitorId = function () {
        var visitorId = this._readVisitorIdFromLocalStorage();
        if (!visitorId) {
            visitorId = this._generateAnonymousVisitorId();
            this._writeVisitorIdFromLocalStorage(visitorId);
        }
        return visitorId;
    };
    OtiIntegrationPendoService.prototype._getPendoDetails = function () {
        var _a;
        var pendoDetails;
        if (!this.pendoDetails) {
            throw new Error('Missing pendo parameters');
        }
        else if (typeof this.pendoDetails === 'function') {
            pendoDetails = this.pendoDetails();
        }
        else {
            pendoDetails = this.pendoDetails;
        }
        return __assign(__assign({}, pendoDetails), { visitor: __assign(__assign({}, pendoDetails.visitor), { id: ((_a = pendoDetails.visitor) === null || _a === void 0 ? void 0 : _a.id) || this._getAnonymousVisitorId() }) });
    };
    OtiIntegrationPendoService.prototype._getPendoLibrary = function () {
        return window.pendo;
    };
    OtiIntegrationPendoService.prototype._getPendoLibraryAsync = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var pendoStack = 0;
            var pendoTimeout = window.setInterval(function () {
                var pendoLib = _this._getPendoLibrary();
                if (pendoLib && typeof pendoLib.isReady === 'function') {
                    clearInterval(pendoTimeout);
                    resolve(pendoLib);
                }
                else if (pendoStack > 100) {
                    clearInterval(pendoTimeout);
                    reject(new Error('Unable to load pendo library'));
                }
                else {
                    pendoStack++;
                }
            }, 50);
        });
    };
    OtiIntegrationPendoService.prototype._getVisitorId = function () {
        var _a;
        var pendoDetails = this._getPendoDetails();
        if (!((_a = pendoDetails.visitor) === null || _a === void 0 ? void 0 : _a.id)) {
            throw new Error('Unable to determine visitor id');
        }
        return pendoDetails.visitor.id;
    };
    OtiIntegrationPendoService.prototype._getVisitorIdLocalStorageKey = function () {
        return "_oti_visitorId.".concat(this.pendoKey);
    };
    OtiIntegrationPendoService.prototype._getVisitorPayload = function () {
        var payload = this.pendoVisitorPayload;
        if (typeof this.pendoVisitorPayload === 'function') {
            payload = this.pendoVisitorPayload(this._getVisitorId());
        }
        if (!payload) {
            payload = [
                {
                    visitorId: this._getVisitorId(),
                }
            ];
        }
        return payload;
    };
    OtiIntegrationPendoService.prototype._loadScript = function (pendoUrl, pendoKey) {
        var script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('class', "optanon-category-".concat(cookies_category_model_1.CookiesCategory.FUNCTIONAL));
        var parsedPendoUrl = pendoUrl.replace(/\$\{pendoKey}/g, pendoKey);
        script.text = "\n                  (function() {\n                    (function(p, e, n, d, o) { \n                      let v, w, x, y, z; \n                      o = p[d] = p[d] || {}; \n                      o._q = [];\n                      v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; \n                      for (w = 0, x = v.length; w < x; ++w)(function(m) {\n                        o[m] = o[m] || function() {o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); }; \n                      })(v[w]);\n                      y = e.createElement(n); \n                      y.async = !0; \n                      y.src = '".concat(parsedPendoUrl, "';\n                      z = e.getElementsByTagName(n)[0]; \n                      z.parentNode.insertBefore(y, z); \n                    })(window, document, 'script', 'pendo');\n                  })();\n              ");
        var headerEl = document.getElementsByTagName('head')[0];
        if (headerEl) {
            headerEl.appendChild(script);
        }
    };
    OtiIntegrationPendoService.prototype._notifyInitialCookieSettingsDelayed = function (nextActiveGroups) {
        var _this = this;
        if (this.initTimeout) {
            clearTimeout(this.initTimeout.timeout);
            var promise_1;
            return promise_1 = new Promise(function (resolve, reject) {
                _this.initTimeout = {
                    promise: promise_1,
                    nextActiveGroups: nextActiveGroups,
                    timeout: window.setTimeout(function () {
                        if (_this.initTimeout) {
                            _this._notifyInitialCookieSettings(_this.initTimeout.nextActiveGroups).then(resolve).catch(reject);
                            _this.initTimeout = null;
                        }
                        else {
                            reject(new Error('Notify timeout break unexpectedly'));
                        }
                    }, 1000),
                    reject: reject
                };
            });
        }
        else {
            var promise_2;
            return promise_2 = new Promise(function (resolve, reject) {
                _this.initTimeout = {
                    promise: promise_2,
                    nextActiveGroups: nextActiveGroups,
                    timeout: window.setTimeout(function () {
                        if (_this.initTimeout) {
                            _this._notifyInitialCookieSettings(_this.initTimeout.nextActiveGroups).then(resolve).catch(reject);
                            _this.initTimeout = null;
                        }
                        else {
                            reject(new Error('Notify timeout break unexpectedly'));
                        }
                    }, 1000),
                    reject: reject
                };
            });
        }
    };
    OtiIntegrationPendoService.prototype._notifyInitialCookieSettings = function (nextActiveGroups) {
        return __awaiter(this, void 0, void 0, function () {
            var dnpValue, targetingCookieValue, dnpPromise, metaPromise;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dnpValue = nextActiveGroups.indexOf(cookies_category_model_1.CookiesCategory.FUNCTIONAL) === -1;
                        targetingCookieValue = nextActiveGroups.indexOf(cookies_category_model_1.CookiesCategory.TARGETING) === -1 ? 'NO' : 'YES';
                        this.logService.log('CookiesPreference Init dnp=' + dnpValue + ', targetingCookieValue=' + targetingCookieValue);
                        if (!(this.pendoOptimizeRequest && this._sessionMatchPendoCategories(dnpValue, targetingCookieValue))) return [3 /*break*/, 1];
                        this.logService.log('CookiesPreference up to date. Verified from session');
                        this._setPendoAppEnabled(dnpValue);
                        return [3 /*break*/, 4];
                    case 1: 
                    /* _createVisitorId() is invoked for the first time to make sure that the visitor exists in Pendo to
                    further invoke _callDNP() or _updateCustomMetadataField(). If the visitor is not existing
                    then these 2 API calls will fail with a 404 visitor not found */
                    return [4 /*yield*/, this._createVisitorId()];
                    case 2:
                        /* _createVisitorId() is invoked for the first time to make sure that the visitor exists in Pendo to
                        further invoke _callDNP() or _updateCustomMetadataField(). If the visitor is not existing
                        then these 2 API calls will fail with a 404 visitor not found */
                        _a.sent();
                        dnpPromise = this._callDNP(dnpValue);
                        metaPromise = this._updateCustomMetadataField(targetingCookieValue);
                        dnpPromise.then(function () { return _this._setPendoAppEnabled(dnpValue); });
                        if (!this.pendoOptimizeRequest) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._sessionWritePendoCategories(dnpPromise, metaPromise)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OtiIntegrationPendoService.prototype._notifyUpdateCookieSettings = function (nextActiveGroups, prevActiveGroups) {
        return __awaiter(this, void 0, void 0, function () {
            var pevDNPValue, nxtDNPValue, FunctionalCategoryChanged, prvTargetingCookieValue, nxtTargetingCookieValue, TargetingCategoryChanged, dnpPromise, metaPromise;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pevDNPValue = prevActiveGroups.indexOf(cookies_category_model_1.CookiesCategory.FUNCTIONAL) === -1;
                        nxtDNPValue = nextActiveGroups.indexOf(cookies_category_model_1.CookiesCategory.FUNCTIONAL) === -1;
                        FunctionalCategoryChanged = pevDNPValue != nxtDNPValue;
                        prvTargetingCookieValue = prevActiveGroups.indexOf(cookies_category_model_1.CookiesCategory.TARGETING) === -1 ? 'NO' : 'YES';
                        nxtTargetingCookieValue = nextActiveGroups.indexOf(cookies_category_model_1.CookiesCategory.TARGETING) === -1 ? 'NO' : 'YES';
                        TargetingCategoryChanged = prvTargetingCookieValue != nxtTargetingCookieValue;
                        this.logService.log('CookiesPreference Update' +
                            ' dnp=' +
                            nxtDNPValue +
                            ', targetingCookieValue=' +
                            nxtTargetingCookieValue +
                            (FunctionalCategoryChanged ? ', functional' : '') +
                            (TargetingCategoryChanged ? ', targeting' : ''));
                        if (!(FunctionalCategoryChanged || TargetingCategoryChanged)) return [3 /*break*/, 2];
                        dnpPromise = void 0;
                        if (FunctionalCategoryChanged) {
                            dnpPromise = this._callDNP(nxtDNPValue);
                            dnpPromise.then(function () { return _this._setPendoAppEnabled(nxtDNPValue); });
                        }
                        else {
                            dnpPromise = Promise.resolve(nxtDNPValue);
                        }
                        metaPromise = void 0;
                        if (TargetingCategoryChanged) {
                            metaPromise = this._updateCustomMetadataField(nxtTargetingCookieValue);
                        }
                        else {
                            metaPromise = Promise.resolve(nxtTargetingCookieValue);
                        }
                        if (!this.pendoOptimizeRequest) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._sessionWritePendoCategories(dnpPromise, metaPromise)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    OtiIntegrationPendoService.prototype._readVisitorIdFromLocalStorage = function () {
        var visitorSortedData = localStorage.getItem(this._getVisitorIdLocalStorageKey());
        var visitorSortedObject = visitorSortedData ? JSON.parse(visitorSortedData) : undefined;
        return visitorSortedObject === null || visitorSortedObject === void 0 ? void 0 : visitorSortedObject.value;
    };
    OtiIntegrationPendoService.prototype._updateCustomMetadataField = function (targetingCookieValue) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.logService.log('UpdateMetadata val=', targetingCookieValue);
            if (!_this.pendoMetadataUrl || !_this.pendoMetadataMethod) {
                throw new Error('Missing pendo parameters');
            }
            _this._executeDelayedRequest(_this._applyTemplatesToUrl(_this.pendoMetadataUrl), _this.pendoMetadataMethod, JSON.stringify(targetingCookieValue))
                .then(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.logService.log('UpdateMetadata success');
                    resolve(targetingCookieValue);
                    return [2 /*return*/];
                });
            }); })
                .catch(function (error) {
                console.error('There was an error!', error);
                reject();
            });
        });
    };
    OtiIntegrationPendoService.prototype._setPendoAppEnabled = function (dnpValue) {
        if (!dnpValue) {
            this._enablePendo();
        }
        else {
            this._disablePendo();
        }
    };
    OtiIntegrationPendoService.prototype._sessionMatchPendoCategories = function (dnp, targetingCookieValue) {
        var categories = this._sessionReadPendoCategories();
        return categories != null
            && ((categories === null || categories === void 0 ? void 0 : categories.functionalCookies) === 'true') == dnp
            && categories.targetingCookies == targetingCookieValue;
    };
    OtiIntegrationPendoService.prototype._sessionReadPendoCategories = function () {
        var result = null;
        if (typeof window.sessionStorage !== 'undefined') {
            var visitorId = this._getVisitorId();
            var categoriesString = window.sessionStorage.getItem('pendo_categories_' + visitorId);
            result = categoriesString ? JSON.parse(categoriesString) : null;
            if (result != null && (result.functionalCookies == null || result.targetingCookies == null)) {
                result = null;
            }
        }
        return result;
    };
    OtiIntegrationPendoService.prototype._sessionWritePendoCategories = function (dnpPromise, metaPromise) {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this.sessionWriteTimeout != null) {
                console.error("Previous session writing has not finished correctly");
                clearInterval(_this.sessionWriteTimeout);
                _this.sessionWriteTimeout = null;
            }
            var error = false;
            var dnp = null;
            dnpPromise
                .then(function (result) { return dnp = result; })
                .catch(function () { return error = true; });
            var targetingCookieValue = null;
            metaPromise
                .then(function (result) { return targetingCookieValue = result; })
                .catch(function () { return error = true; });
            _this.sessionWriteTimeout = window.setInterval(function () {
                if (_this.sessionWriteTimeout != null) {
                    if (dnp != null && targetingCookieValue != null) {
                        _this._sessionDoFinalWritePendoCategories(dnp, targetingCookieValue);
                        resolve();
                        clearInterval(_this.sessionWriteTimeout);
                        _this.sessionWriteTimeout = null;
                    }
                    else if (error) {
                        clearInterval(_this.sessionWriteTimeout);
                        _this.sessionWriteTimeout = null;
                    }
                }
            }, 1000);
        });
    };
    OtiIntegrationPendoService.prototype._sessionDoFinalWritePendoCategories = function (dnp, targetingCookieValue) {
        var visitorId = this._getVisitorId();
        var key = 'pendo_categories_' + visitorId;
        var categories = {
            functionalCookies: String(dnp).toString(),
            targetingCookies: targetingCookieValue
        };
        window.sessionStorage.setItem(key, JSON.stringify(categories));
        this.logService.log("Write session flag key=".concat(key), categories);
    };
    OtiIntegrationPendoService.prototype._storePendoEvent = function (evt) {
        this.untrackedEvents.push(evt);
    };
    OtiIntegrationPendoService.prototype._trackPendoEvent = function (evt) {
        var _a;
        this.logService.log('Pendo. Track event', evt.name, evt.props);
        (_a = this._getPendoLibrary()) === null || _a === void 0 ? void 0 : _a.track(evt.name, evt.props);
    };
    OtiIntegrationPendoService.prototype._writeVisitorIdFromLocalStorage = function (visitorId) {
        var visitorSorteData = { value: visitorId };
        localStorage.setItem(this._getVisitorIdLocalStorageKey(), JSON.stringify(visitorSorteData));
    };
    OtiIntegrationPendoService.prototype.enabled = function () {
        return !!this.pendoUrl && !!this.pendoKey;
    };
    OtiIntegrationPendoService.prototype.configure = function (_a) {
        var options = _a.options;
        this.pendoCNameContent = options.pendo_cname_content;
        this.pendoCNameData = options.pendo_cname_data;
        this.pendoKey = options.pendo_key;
        this.pendoDetails = options.pendo_details;
        this.pendoOptimizeRequest = options.pendo_optimize_requests === true;
        this.pendoDnpUrl = options.pendo_dnp_url || '/pendo/dnp';
        this.pendoDnpMethod = options.pendo_dnp_method || 'PUT';
        this.pendoVisitorUrl = options.pendo_visitor_url || '/pendo/visitor';
        this.pendoVisitorMethod = options.pendo_visitor_method || 'POST';
        this.pendoVisitorPayload = options.pendo_visitor_payload;
        this.pendoMetadataUrl = options.pendo_metadata_url || '/pendo/metadata';
        this.pendoMetadataMethod = options.pendo_metadata_method || 'PUT';
        this.pendoUrl = options.pendo_url || 'https://cdn.pendo.io/agent/static/${pendoKey}/pendo.js';
        this.pendoVisitorIdGenerator = options.pendo_visitor_id_generator;
        this.requestHeaders = options.request_headers;
        this.requestWithCredentials = options.request_with_credentials === true;
    };
    OtiIntegrationPendoService.prototype.init = function () {
        var _this = this;
        if (!this.pendoUrl || !this.pendoKey) {
            throw new Error('Missing pendo parameters');
        }
        this.logService.log('Initialize pendo integration');
        this._loadScript(this.pendoUrl, this.pendoKey);
        this.cookiePreferenceChange$.subscribe(function (_a) {
            var initial = _a.initial, next = _a.next, prev = _a.prev;
            return _this.notifyCookieSettings(initial, next, prev);
        });
    };
    OtiIntegrationPendoService.prototype.notifyCookieSettings = function (optanonInitiallyLoad, nextActiveGroups, prevActiveGroups) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!optanonInitiallyLoad) return [3 /*break*/, 4];
                        if (!!nextActiveGroups) return [3 /*break*/, 1];
                        this.logService.log('Missing CookiesPreference');
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this._notifyInitialCookieSettingsDelayed(nextActiveGroups)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 7];
                    case 4:
                        if (!(!nextActiveGroups || !prevActiveGroups)) return [3 /*break*/, 5];
                        this.logService.log('Missing CookiesPreference');
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, this._notifyUpdateCookieSettings(nextActiveGroups, prevActiveGroups)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    OtiIntegrationPendoService.prototype.track = function (evt) {
        if (this.isTrackingEnabled) {
            this._trackPendoEvent(evt);
        }
        else {
            this._storePendoEvent(evt);
        }
    };
    OtiIntegrationPendoService.prototype.updateVisitorPayload = function (pendoVisitorPayload, pendoDetails) {
        return __awaiter(this, void 0, void 0, function () {
            var cookieSettings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (pendoVisitorPayload) {
                            this.pendoVisitorPayload = pendoVisitorPayload;
                        }
                        if (pendoDetails) {
                            this.pendoDetails = pendoDetails;
                        }
                        cookieSettings = this.cookiePreferenceChange$.getLastValue();
                        this.logService.log("updateVisitorPayload. Cookies defined=".concat(!!(cookieSettings === null || cookieSettings === void 0 ? void 0 : cookieSettings.next)));
                        if (!cookieSettings) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._notifyInitialCookieSettings(cookieSettings.next)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return OtiIntegrationPendoService;
}());
exports.OtiIntegrationPendoService = OtiIntegrationPendoService;
